import { ExclamationTriangleIcon } from '@heroicons/react/24/solid';

/**
 * ScheduleWarning - Warning message for scheduled capability execution
 *
 * Displays a warning about potential uncontrolled traffic when scheduling
 * automated capability execution in client environments.
 */
export function ScheduleWarning() {
  return (
    <div className="mb-6 rounded-lg border border-yellow-500/30 bg-yellow-500/10 p-4">
      <div className="flex gap-3">
        <ExclamationTriangleIcon className="mt-0.5 size-5 flex-shrink-0 text-yellow-500" />
        <div className="flex flex-col gap-1">
          <h4 className="text-sm font-semibold text-yellow-500">
            Scheduling Automated Execution
          </h4>
          <p className="text-chariot-text-secondary text-sm">
            Scheduling automated execution of capabilities may lead to
            uncontrolled traffic within the client&apos;s environment. Please
            ensure this is desired and in agreement with the client&apos;s
            requests and constraints.
          </p>
        </div>
      </div>
    </div>
  );
}
